import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Favorite from "@material-ui/icons/Favorite";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { blue } from "@material-ui/core/colors";
import InfoIcon from "@material-ui/icons/Info";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { AccordionDetails, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import grey from "@material-ui/core/colors/grey";
import CancelIcon from "@material-ui/icons/Cancel";
import { red } from "@material-ui/core/colors";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleRight,faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import RedCross from "../../../Icons/RedCross";
import { useTranslation } from "react-i18next";
// import unmapicon from "./unmap.svg";
import {useDispatch,addContexts,useSelector} from "../../../Redux";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";


const l_grey = grey[300];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    // padding: `0px ${theme.spacing(3)}px`,
    padding: 0,
  },
  listItem: {
    padding: 0,
  },
  listItemText: {
    flex: "0 1 auto",
    marginRight: "7px",
  },
  body1: {
    fontWeight: "bold",
  },
  listIcon: {
    minWidth: "unset",
    color: "black",
  },
  // arrow: {
  //   color: theme.palette.common.white,
  // },
  // tooltip: {
  //   backgroundColor: theme.palette.common.white,
  // },
  customWidth: {
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 1px 10px black",
    // border: "0.1px solid black",
    maxWidth: 160,
    fontSize: 12,

    // border: "0.5px solid black",
    // color: "black",
  },
  mapButton:{
    marginLeft:"5px !important",
    backgroundColor:"#0072c6",
    color:"#ffffff", 
    border:"none",
    borderRadius:"2px",
    height:"22px !important",
    fontSize:"10px",
    display:"flex", 
    alignItems:"center"
  }
  // bulletIcon: {
  //   fontSize: "10px",
  //   marginRight: "5px",
  // },
}));

// function BootstrapTooltip(props) {
  

//   return <Tooltip arrow classes={classes} {...props} />;
// }

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const BlueCheckbox = withStyles({
  root: {
    color: blue[400],
    "&$checked": {
      color: blue[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ItemCustom = (props) => {
  const {t}=useTranslation();
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";    
  const classes = useStyles();
  const contexts = GetStateFromData(props.containerId);

  const {MapId, setMapId
    // , parentChildCustom
  }=contexts.contexts;


  const [data, setData] = React.useState(0);
  const [checkboxchecked, setCheckboxchecked] = React.useState(
    props.arr
      ? props.arr.indexOf(props.dt["label"]) === -1
        ? false
        : true
      : props.dt["checked"] == "y"
      ? true
      : false
  );

  //   const [checkboxchecked, setCheckboxchecked] = React.useState(
  //     props.dt["checked"] == "y" ? true : false
  //   );
  //   const [patharr, setPatharr] = React.useState([]);
  const [recent, setRecent] = React.useState(
    props.dt["mapped"] == "y" ? true : false
  );
  const [map, setMap] = React.useState(
    props.dt["mapped"] == "y" ? true : false
  );
  const [hiding, setHiding] = React.useState(false);
  const [checked, setChecked] = React.useState(
    props.dt["mapped"] == "y" ? true : false
  );
  //   // const [filter, setFilter] = React.useState("");
  //   // const [first, setFirst] = React.useState(isfirst);

  const [dataColor, setDataColor] = React.useState(false);

  const func = () => {
    if (!hiding) setHiding(!hiding);
  };

  const scndfunc = (boxes) => {
    boxes++;
    //  console.log("boxes", boxes);
    return boxes;
  };

  const temp = () => {
    alert(
      `${props.totalparent.replace(/\s/g, "")}${props.random.replace(
        /\s/g,
        "_"
      )} with type ${typeof props.dt[props.random]}`
    );
    // console.log(props.totalparent);
  };
  var res = new Array();
  var patharr;


  // useEffect(()=>{
  //   if(props.saveInJson){
  //     // props.dt[props.random] = props.stateForCustomServiceJson;
  //     console.log("saveInJson True");
  //   }else{
  //     props.dt[props.random] = "";
  //     console.log("saveInJson Yes We Here");
  //     console.log("saveInJson False");
  //   }
  // },[props.saveInJson])

  //  console.log("saveInJson abcdefgh ", props.saveInJson);


  const getpath = (text) => {
    var pos = 0;
    var inipos = 0;
    var ans = "";
    while (pos >= 0 && pos < text.length) {
      pos = text.indexOf(".", pos + 1);
      ans = text.substring(inipos, pos);
      inipos = pos + 1;
      if (pos == -1) break;
      res.push(ans);
    }
    // console.log(res);
    // setPatharr(res);
    patharr = res;
    // return res;
    return
  };

  const modifyjson = (res, json, i, property) => {
    //  console.log("modifyjson called");
    if (res.length < i) {
      //  console.log("empty path");
      return;
    }

    for(let k in json){
      if(!json.hasOwnProperty(k)){
        continue;
      }
      if (json[k] !== null && typeof json[k] === "object") {
        if (k === res[i]) {
          modifyjson(res, json[k], i + 1, property);
        }
      } else {
        if (k === property) {
          if (json[k] === "n") json[k] = "y";
          else json[k] = "n";
          //  console.log("updated", props.samplejson);
          modifyjson(res, json[k], i + 1, property);
          return;
        }
      }
    };
  };

   

  //  console.log("Item Custom ", props)

  //  console.log("searching ", props.searching);
  //  console.log("searching ", typeof props.searchWord);
  //  console.log("searching ", props.searchWord);

  // var abc="returnCode";

  // if(abc.includes(props.searchWord)){
  //   //  console.log("searching Yes");
  // }else{
  //   //  console.log("searching No");
  // }


  const handleCheckBoxChange = (x) => {
    if (props.increasenumber && props.decreasenumber) {
      if (checkboxchecked) {
        props.decreasenumber();
      } else {
        props.increasenumber();
      }
    }
    if (props.handleArr) {
      props.handleArr(x);
    }
    setCheckboxchecked(!checkboxchecked);
    getpath(props.totalparent);
  };

  const func2 = () => {
    setMap(true);
    setChecked(true);
  };
  const func3 = () => {
    setMap(false);
    setChecked(false);
    setHiding(false);
  };

  // const [showMapButtonState, setShowMapButtonState]= React.useState(false);

  const [showParentValue, setShowParentValue]= React.useState(false);

  function showMapButton(){
        //  console.log("parentMapping parentMapping ", props.parentMapping);

  
        // showMapButtonState={showMapButtonState}
        // setShowMapButtonState={setShowMapButtonState}

        if(props.parentChildCustom === "child")
        {
        if(!props.parentMapping){
          if(props.showMapButtonState==="")
          {
          props.setShowMapButtonState(props.random);
          }else{
            props.setShowMapButtonState("");
          }
          // setShowMapButtonState(!showMapButtonState);
        }
      }
      
 }



  function removeMapButton(){
    // setShowMapButtonState(!showMapButtonState);
  }

    //  console.log("propsprops ", props);

  // function JsonMapButton(jsonData){

    function JsonMapButton(parentData, currentValue, event){

        // console.log("parentData ", parentData);
        // console.log("parentData ", currentValue);

        event.stopPropagation();

        // props.dt[props.random] = props.stateForCustomServiceJson;

        // props.dt[props.random] = MapId;
        props.dt[props.random] = props.selectedMappedValue;

        props.customServiceIds.add(props.selectedMappedValue);
        props.setSelectedMappedValue("");
        props.setShowMapButtonState("");

        // setMapId("");
       // console.log("MappedIDValueInValueIn ", MapId);
       // console.log("MappedIDValueInValueIn ", parentChildCustom);
        //   props.dt[props.random]="abcdef";
        // jsonData.value= props.stateForCustomServiceJson;
        // jsonData.mapped='y';

         setShowParentValue(true);

        //  setShowMapButtonState(false);


        //  props.setStateForCustomServiceJson("");
  }


  function JsonUnMapButton(parentData, currentValue){
    // jsonData.value= '';
    // jsonData.mapped= '';
    // console.log("jsonDataItem ", jsonData);
    // setShowParentValue(false);


    var unmappedSet = new Set();

    props.customServiceIds.forEach(function(value){
      unmappedSet.add(value);
    })

    unmappedSet.delete(props.dt[props.random]);
  

    props.dt[props.random] = "";
    props.setShowMapButtonState("");

    // props.customServiceIds.delete(props.dt[props.random]);
    props.setcustomServiceIds(unmappedSet);

    // setShowMapButtonState(!showMapButtonState);

  }



  // useEffect(() => {
  //   func2();
  //   func3();
  // }, [checked]);

  //   let tempo = ["personal details", "employe id"];


  var inputStyleData={ 
    width: "100%",
    margin: "5px",
    display: "flex",
    alignItems: "center",
    padding: "0px",
 }


var inputStyleDataAfterClick={ 
    width: "100%",
    margin: "5px",
    display: "flex",
    alignItems: "center",
    padding: "0px",
    backgroundColor:"#0072C619"
 }







  // return (
  //   <>
  //     {getpath(props.totalparent)}

  //     <div
  //       key={Math.random() * 10}
  //       style={showMapButtonState ? inputStyleDataAfterClick : inputStyleData}
  //       // style={{
  //       //   width: "100%",
  //       //   margin: "5px",
  //       //   display: "flex",
  //       //   alignItems: "center",
  //       //   padding: "0px"
  //       // }}
  //       onClick={() => {
  //         func();
  //         getpath(props.totalparent);
  //       }}
  //     >
     
  //     {props.dt["mapped"]==='y' ?

  //       <>
  //       <span
  //         style={{
  //           font: "normal normal normal 12px/17px Open Sans",
  //           display: "inline-block",
  //           // marginLeft: "-13px",
  //         }}
  //         onClick={()=>showMapButton()}
  //          key={props.dt["mapped"]}
  //       //   handleMouseEnter={()=>showMapButton()}
  //       //   handleMouseUp={()=>removeMapButton()}
  //       >
  //         {props.dt["label"]} <FontAwesomeIcon key={'faChevronCircle'} icon={faChevronCircleRight} />
  //         <span style={{color:"#0072C6"}}> {props.dt["value"]} </span> 

  //       </span>

       
  //       <span style={{marginLeft:"auto",  color:"red",  fontSize:"10px", marginRight:"14px"
  //           }}
  //             onClick={()=>JsonUnMapButton(props.dt)}
  //             > UnMap &nbsp; <RedCross/> </span>
  //       </>:
        
  //       <>
  //           <span
  //         style={{ font: "normal normal normal 12px/17px Open Sans", display: "inline-block", // marginLeft: "-13px",
  //         }} 
  //         onClick={()=>showMapButton()} key={props.dt["value"]}
  //       >
  //         {props.dt["label"]} 

  //       </span>

  //          {showMapButtonState ?
  //       <button style={{marginLeft:"auto", backgroundColor:"#0072c6", color:"#ffffff", border:"none", borderRadius:"2px",
  //           height:"22px", fontSize:"10px"
  //           }}
  //            key={props.dt["value"]} onClick={()=>JsonMapButton(props.dt)} > Map </button> : null}


  //       </>}

  //       {/* {showMapButtonState ?
  //       <>
  //       <button style={{marginLeft:"auto", backgroundColor:"#0072c6", color:"#ffffff", border:"none", borderRadius:"2px",
  //           height:"22px", fontSize:"10px"
  //   }}
  //   key={props.dt["value"]}
  //   onClick={()=>JsonMapButton(props.dt)}
  //   >Map</button>
  //       </>
  //       : null} */}

    
        
   
  //     </div>
  //   </>
  // );

  useEffect(()=>{
    getpath(props.totalparent)
  },[props.totalparent])
  return (
    <>
      {/* {getpath(props.totalparent)} */}

      <div
        key={Math.random() * 10}
        // style={dataColor ? inputStyleDataAfterClick : inputStyleData}

       style={(props.showMapButtonState=== props.random) ? inputStyleDataAfterClick : inputStyleData}

        // style={inputStyleData}

        // onClick={() => {
        //   func();
        //   getpath(props.totalparent);
        // }}

        // onClick={()=>savingInJson(props.random)}

        onClick={()=>showMapButton()}
      >
     
          
        <span
          style={{ font: "normal normal normal 12px/17px Open Sans",
          display: "inline-block" }}
          // id={props.parentId+"-"+props.dt["label"]}
          childOf="abc"
          //  onClick={()=>savingInJson(props.dt, props.parentId+"-"+props.dt["label"])}
         //  onClick={()=>savingInJson(props.random)}
        >
        

        {/* { (props.searching  && props.random.includes(props.searchWord)) ?
          props.random : ""    
      }  */}

          {props.random}


          {props.dt[props.random] !== ''  ?
          <>
          &nbsp;
          <FontAwesomeIcon key={'faChevronCircle'} icon={translationStyles1? faChevronCircleLeft : faChevronCircleRight} style={{width:"15px",height:"15px"}}/> &nbsp;
            <span  
               style={{
                font: "normal normal 600 12px/17px Open Sans",
                color: "#005EA3"
              }}
            > {props.dt[props.random]} </span> 
          </>
           : "" }
        </span>

             {/* {showMapButtonState ? */}
             {(props.showMapButtonState=== props.random) ?
       <button className={classes.mapButton}
         //     key={props.dt["value"]} 
              onClick={(event)=>JsonMapButton(props.dt, props.random, event)} 
              > {t("Map")} </button> : null}
    

         {props.dt[props.random] !== ''  ?
          <>
               <span style={{marginLeft:"auto",  color:"red",  fontSize:"10px", marginRight:"14px"
             }}
               onClick={()=>JsonUnMapButton(props.dt, props.random)}
             > {t("UnMap")} &nbsp; <RedCross/> </span>
             </>
           : "" }      

        
   
      </div>
    </>
  );














  
};

export default ItemCustom;
